module.exports = __webpack_public_path__ + "static/media/googleLogo.svg.1bf7380f.png";